import refreshGreenIcon from '@library/assets/images/icons/refresh-green-icon.svg';
import refreshGreyIcon from '@library/assets/images/icons/refresh-grey-icon.svg';

export interface AutoTradeIndicatorProps {
  autoTrade: boolean;
  className?: string;
  hasSuggestedLines: boolean;
  isTrading?: boolean;
}

export const AutoTradeIndicator = ({
  autoTrade,
  className = '',
  hasSuggestedLines,
  isTrading = false
}: AutoTradeIndicatorProps) => {
  if (!autoTrade) {
    return null;
  }

  return isTrading && !hasSuggestedLines ? (
    <img
      alt="Auto Trade has no suggested lines"
      className={className}
      src={refreshGreyIcon}
    />
  ) : (
    <img
      alt="Auto Trade Enabled"
      className={className}
      src={refreshGreenIcon}
    />
  );
};
